/**
 * @name: main.js
 * @description: 入口文件
 * @author: wenyongjiang
 * @create: 2020/07/22 10:38:49
 * @update: 2020/07/22 10:38:49
 */
// 若是没有开启Devtools工具，在开发环境中开启，在生产环境中关闭
import Vue from 'vue';
import router from './router/index';
// import store from "./store";
import fetch from '@/assets/modules/fetch';
import validatorManu from '@/assets/modules/validatorManu.js';//表单校验

import * as lf from 'localforage';
import controller from '@/assets/modules/controller';
import fields from '@/assets/modules/fields';
import css from '@/assets/font/iconfont.css';

// 过滤器
import '@/assets/modules/filters';

// 从本地构建引入第三方库、样式
import karmaUI from '@/components/karma-ui/lib/index';
import App from './App';
import '!!vue-style-loader!css-loader!@/components/karma-ui/lib/index.css';

/**
 * 引入业务组件、项目内组件
 */
import '@/components/index';

import '@/assets/modules/directives/validate';
// 引入本项目style
import '@/assets/style/index.css';
// 引入拖拽
import VueDND from 'awe-dnd';

import DatePicker from 'iview';
import Select from 'iview'
import 'iview/dist/styles/iview.css';
Vue.use('DatePicker', DatePicker);
Vue.use('Select', Select);

if (process.env.NODE_ENV == 'development') {
  Vue.config.devtools = true;
} else {
  Vue.config.devtools = false;
}

Vue.use(karmaUI, {
  // 可全局配置参数
  // KSwitch: {
  //   onContent: Vue.compile(
  //     '<k-icon name="icon-qiyong" size="20" color="#fff" />'
  //   ).render,
  //   offContent: Vue.compile(
  //     '<k-icon name="icon-jinyong" size="20" color="#fff" />'
  //   ).render
  // },
  KButton: {
    type: 'default',
    tag: 'button'
  },
  KPagination: {
    pageSize: 20,
    size: 'small',
    layout: 'total,prev,pager,next,jumper'
    // pageSizes: () => [15, 20, 30, 40, 50]
  },
  KTable: {
    size: 'big',
    minContent: false,
    resizeWidth: false,
    indexText: '序号',
    emptyText: () => {
      const empty = Vue.compile('<y-empty />');
      return empty.render;
    }
  },
  KTable2: {
    minContent: false,
    resizeWidth: false
  },
  KDrawer: {
    direction: 'right',
    hasMask: false
  },
  KTree: {
    icon: ['k-icon-arrow-right-solid', 'k-icon-sort-down', '']
  },
  KScrollbar: {
    trackStyle: {
      backgroundColor: 'rgba(255,255,255,.2)'
    },
    thumbStyle: {
      backgroundImage: 'linear-gradient(90deg,rgba(255,255,255,.3),rgba(166,166,166,.6),rgba(255,255,255,.1))'
    }
  },
  Tips: {
    icon: () => ({
      warning: {
        name: 'icon-jinggaozhuyi'
      },
      success: {
        name: 'icon-yuyuechenggong'
      },
      error: {
        name: 'icon-shibaibaocuo-'
      }
    })
  }
});

Vue.use(VueDND);
// 图片预览
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
Vue.use(Viewer,{
  defaultOptions: {
    zIndex: 999999,
    title: false,
    navbar: false,
    toolbar: {
      next: false,
      play: false,
      prev: false,
      reset: true,
      rotateLeft: true,
      rotateRight: true,
      zoomIn: true,
      zoomOut: true
    },
  }
});

Vue.fetch = Vue.prototype.$fetch = fetch;
Vue.lf = Vue.prototype.$lf = lf;
window.controller = Vue.controller = Vue.prototype.$controller = controller;
Vue.fields = Vue.prototype.$fields = fields;
Vue.validatorManu = Vue.prototype.$validatorManu = validatorManu;

Vue.config.productionTip = false;

router.afterEach((to, from) => {
  // if (to.meta.title) {
  //   window.top.document.title = `${to.query.documentTitle || to.meta.title}`;
  // }
});

const ins = new Vue({
  data: {
    startDate: Vue.filters.date(new Date()), // 默认查询开始日期
    endDate: Vue.filters.date(new Date()), // 默认查询结束日期
    preTotalRows: 10, // 默认新增单据时的展示行数
    pageSize: 20, // 每页数据条数
    tableHeightX: 'calc(100vh - 130px)', // 预置的表格高度
    tableHeightXX: 'calc(100vh - 182px)',
    tableHeightXXX: 'calc(100vh - 234px)',
    tableHeightXXXX: 'calc(100vh - 286px)'
  },
  router,
  // store,
  methods: {
    tip(content, type = 'warning', time = 2000, icon = {
      name: '',
      size: '',
      color: ''
    }) {
      return this.$tips({
        content,
        type,
        icon
      }).hide(time);
    }
  },
  render: h => h(App)
}).$mount('#app');

export default ins;
